:host {
  display: flex;
  gap: $xp-ref-spacing-4;
  overflow: visible;
}

:host(.horizontal) {
  flex-direction: row;
  align-items: center;
}

:host(.horizontal) .bar {
  flex: 1;
  height: $xp-ref-size-1;
}

:host(.vertical) {
  flex-direction: column;
  justify-content: start;
}

:host(.vertical) .bar {
  flex: 1 1 0px;
  min-height: 50px;
  width: $xp-ref-size-1;
}

.bar {
  background-color: $xp-ref-color-semantic-neutral-high-emphasis;
}
